import React from 'react'
import PropTypes from 'prop-types'
import FormLogin from './FormLogin'
import './index.css'

export class FormLoginModal extends React.Component {
  render () {
    const { subject, ...otherProps } = this.props
    return (
      <div className='mofo'>
        <div className='mofo-con'>
          <div className='lf'>
            <h3>Před změnou {subject} je nutno znovu zadat přihlašovací údaje.</h3>
            <FormLogin forRelogin {...otherProps} />
          </div>
        </div>
      </div>
    )
  }
}

FormLoginModal.propTypes = {
  subject: PropTypes.string
}

export default FormLoginModal



// WEBPACK FOOTER //
// ./src/components/UserForms/FormLoginModal.js